import React from "react";

interface OverlineTextProps {
    text: string;
}

export const OverlineText = ({text}: OverlineTextProps) => {
    return <div className={"OverlineText font-i block uppercase tracking-wider font-semibold text-xs 2xl:text-base"}>{text}</div>;
};
